"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "lierna": {
    "b54fd9fc": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "skipSearch": false
    }],
    "casate": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa34d8cf": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "af036753": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "skipSearch": false
    }],
    "ciserino": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d9778ac6": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "skipSearch": false
    }],
    "genico": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "61f37762": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "skipSearch": false
    }],
    "giussana": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "803df01b": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "skipSearch": false
    }],
    "grumo": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7107c7ed": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "skipSearch": false
    }],
    "mugiasco": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a94d1160": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "skipSearch": false
    }],
    "olcianico": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e2de5b9a": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "skipSearch": false
    }],
    "sornico": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6c3b20b6": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "8c1a74f9",
      "slug": "lierna",
      "name": "Lierna",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;